<template>
  <span class="token-logo" :style="{ width: size + 'px', height: size + 'px' }">
    <img
      v-if="src && !failed"
      :src="src"
      :alt="name"
      loading="lazy"
      @error="failed = true"
    />
    <span v-else class="fallback">
      <InvIcon name="pie" />
    </span>
  </span>
</template>

<script>
import InvIcon from "@/components/invest/InvIcon.vue";

export default {
  name: "InvestTokenLogo",
  components: { InvIcon },
  props: {
    src: { type: String, default: "" },
    name: { type: String, default: "" },
    size: { type: Number, default: 48 },
  },
  data() {
    return { failed: false };
  },
  watch: {
    src() {
      this.failed = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.token-logo {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #d0d5e0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #8791a7;
}
</style>
